var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-controller"},[_c('img',{attrs:{"src":_vm.src},on:{"click":_vm.onClick}}),_c('audio',{attrs:{"id":"foreground","volume":"1.0","autoplay":""}}),_c('audio',{attrs:{"id":"background","volume":"0.6","autoplay":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }